module.exports = __webpack_public_path__ + "static/media/gallaxy-background-available-art-page.b538be17.webp";